export default __webpack_public_path__ + "static/media/hero2.00778998.svg";